import React, { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'

// Components
import Header from './components/Header'
import Footer from './components/Footer'

// Pages
import Home from './pages/Home'
import Services from './pages/Services'
import ServiceDetail from './pages/ServiceDetail'
import Gallery from './pages/Gallery'
import About from './pages/About'
import Contact from './pages/Contact'
import Prisestimater from './pages/Prisestimater'
import PrivacyPolicy from './pages/PrivacyPolicy'

// ScrollToTop helper component to ensure page scrolls to top on route change
function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50 text-slate-900 antialiased">
      <ScrollToTop />
      {/* Header Navigation */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ydelser" element={<Services />} />
          <Route path="/ydelser/:slug" element={<ServiceDetail />} />
          <Route path="/galleri" element={<Gallery />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/prisestimater" element={<Prisestimater />} />
          <Route path="/privatlivspolitik" element={<PrivacyPolicy />} />
          {/* Fallback route */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default App
